import { useState, createContext, useContext } from 'react';

export const EditFormContext = createContext(null);

export const useEditForm = () => {
	return useContext(EditFormContext);
};

export default function EditFormProvider(props) {
	const [saveBtnKeyClick, setSaveBtnKeyClick] = useState(null);

	const value = {
		saveBtnKeyClick,
		setSaveBtnKeyClick
	};

	return <EditFormContext.Provider value={value}>{props.children}</EditFormContext.Provider>;
}
